// extracted by mini-css-extract-plugin
export var lbContainerOuter = "B_t8";
export var lbContainerInner = "B_t9";
export var movingForwards = "B_vb";
export var movingForwardsOther = "B_vc";
export var movingBackwards = "B_vd";
export var movingBackwardsOther = "B_vf";
export var lbImage = "B_vg";
export var lbOtherImage = "B_vh";
export var prevButton = "B_vj";
export var nextButton = "B_vk";
export var closing = "B_vl";
export var appear = "B_vm";